import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Link, useParams } from "react-router-dom"
import { bindActionCreators } from "redux"
import { callCompanyViewGet, callCompanyPost, callCompanyPut, callCompanyClearView } from "../../actions/companies"

let CompanyEdit = ({ setPageAttr, methods: { callCompanyPost, callCompanyViewGet, callCompanyPut, callCompanyClearView }, view }) => {
    const params = useParams()
    const [id] = useState(!params.id ? '' : params.id)
    const [name, setName] = useState('')

    useEffect(() => {
        callCompanyClearView()
        let tabs
        if (!id) {
            tabs = [
                {
                    active: false,
                    to: '/companies',
                    label: 'Informações'
                },
                {
                    active: true,
                    to: '/companies/add',
                    label: 'Adicionar'
                }
            ]
        } else {
            callCompanyViewGet(id)
            tabs = [
                {
                    active: false,
                    to: '/companies',
                    label: 'Informações'
                },
                {
                    active: true,
                    to: '/companies/edit/' + id,
                    label: 'Editar'
                }
            ]
        }

        setPageAttr({
            title: 'Empresa - ' + (!id ? 'Novo' : 'Editar'),
            caption: 'Preencha os campos para inserir as informações',
            btns: [],
            tabs: tabs
        })
    }, [setPageAttr, id, callCompanyViewGet, callCompanyClearView])

    useEffect(() => {
        setName(view.name)
    }, [view])

    const finishedSubmit = () => {
        setName('')
        window.navigate('/companies')
    }

    const submit = (e) => {
        e.preventDefault()

        let data = {
            name: name,
        }

        if (!id) {
            callCompanyPost(data, () => finishedSubmit())
        } else {
            callCompanyPut(id, data, () => finishedSubmit())
        }
    }

    return (
        <form onSubmit={submit}>
            <div className="form-row">
                <div className="col-md-12">
                    <div className="form-row">
                        <div className="col-md-6 form-group">
                            <label className="required">Nome:</label>
                            <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="clearfix text-left mt-3">
                <button className="btn btn-primary" type="submit"><i className="mr-1 fas fa-save fa-white"></i>Salvar</button>
                <Link to={'/companies'} className="btn btn-secondary ml-3"><i className="fas fa-arrow-left mr-1"></i>Voltar</Link>
            </div>
        </form>
    )
}

const mapStateToProps = ({ register: { companies: { view } } }) => ({
    view: view,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callCompanyViewGet,
            callCompanyPost,
            callCompanyClearView,
            callCompanyPut
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyEdit)